import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { IcoStar, Select } from '../../../components'
import './npsconcorrentesprodutos.scss'
import Filter from './filter/filter'
import Grafico from './grafico'
import { carregarGrafico, filterHandle } from './redux/npsconcorrentesprodutosActions'
import { setInfoGrupo, setProjeto } from '../../../layout/redux/layoutActions'
import Video from '../../videos/video'
import CriarDashboardButton from '../../dashboard/criardashboardbutton'
import { modalOpen } from '../../../layout/redux/layoutActions'
import Criar from '../../dashboard/criar'


export default () => {
  const dispatch = useDispatch()
  const { filters, grupos, grupo, sistema } = useSelector(state=> state.layoutState)
  
  const { totalAvaliacao, projeto, filtersProvisorio, projetos } = useSelector(state=> state.npsconcorrentesprodutosState)

  const nlsContexto = require(`../../centralAjuda/nlscontexto/${sistema.idioma}.json`)

  const nls = require(`../csatcliente/nls/${sistema.idioma}.json`)

  const labelgraf = {
    atual: nls.labelgrafico.atual,
    anterior: nls.labelgrafico.anterior
  };

  //USADO CASO O USUÁRIO DER REFRESH NA PÁGINA
  useEffect(() => {
  const wasRefreshed = sessionStorage.getItem('wasRefreshed')
  
  if (wasRefreshed === 'true' && projeto && projeto.id) {
    sessionStorage.removeItem('wasRefreshed')
    dispatch(setProjeto(projeto)) // ← Isso já dispara toda a cadeia!
  }

  const handleBeforeUnload = () => {
    sessionStorage.setItem('wasRefreshed', 'true')
  }
  
  window.addEventListener('beforeunload', handleBeforeUnload)
  return () => window.removeEventListener('beforeunload', handleBeforeUnload)
}, [projeto, dispatch])



  //console.error(grupos, 'GRUPOS:');
  //console.error(grupo, 'GRUPO:');

  useEffect(()=> {
    if (projeto.id) {
      if (filters.typeSelect) {
        console.error(filters.typeSelect, 'FILTERS TYPESELECT EM USEEFFECT');
        dispatch(filterHandle({projetoID: projeto.id, grupo, params: filters, filtersProvisorio, typeSelect: filters.typeSelect, idioma: sistema.idiomaIdValue, labelgraf}))
        console.error('ENTROU USE EFFECT NPSCONCORRENTESPRODUTOS PARTE 1');
        console.error('PROJECTID:' + projeto.id);
      } else{
        dispatch(carregarGrafico({projetoID: projeto.id, grupo, params: {TipoBusca: 'Ciclo', MesCliclo: '2023-01', Comparacao: true}, idioma: sistema.idiomaIdValue, labelgraf}))
        console.error('ENTROU USE EFFECT NPSCONCORRENTESPRODUTOS PARTE 2');
      }
        
      }
    console.error('ENTROU USE EFFECT NPSCONCORRENTESPRODUTOS');
  }, [projeto,grupo])

  const handleFormFilter = (e) => {
    console.error(e.value,'PROJETO SELECIONADO');
    dispatch(setProjeto(e.value))
  }

  const handleGrupo = (e) => {
    console.error(e.value,'GRUPO SELECIONADO');
    dispatch(setInfoGrupo(e.value))

  }

  const handleAbrirCriarDashboard = () => {
  dispatch(modalOpen('criar'))
}


  
  return (
    <div className='box-npsconcorrentesprodutos'>
      <div className='box-npsconcorrentesprodutos-topinfo'>
        <div>
          <div className='box-npsconcorrentesprodutos-topinfo-select'>
            {console.error(projeto,'PROJETO DENTRO DE SELECT')}
            <Select 
              name='projeto'
              label={nls.projeto}
              options={projetos}
              selected={projeto}
              action={(e)=> handleFormFilter(e)}
              selectedItem={false}
              optionLabel='nomeProjeto'
              optionValue='id'
            />
          </div>

          {grupos && grupos.some(g => g?.name && g.name.trim() !== '') ? (
            <div className='box-npsconcorrentesprodutos-topinfo-select'>
              <Select 
                name='grupo'
                label={nls.grupo}
                options={grupos}
                selected={grupo}
                action={(e)=> handleGrupo(e)}
                selectedItem={false}
              />
            </div>
          ) : null}

        </div>
        <div className='box-npsoncorrentesprodutos-topinfo-avaliacao'>
            <label>{nls.numerodeavaliacoes}</label>
            <IcoStar />
            <strong>{totalAvaliacao?totalAvaliacao:0}</strong>
        </div>
      </div>
      <Filter />

      <div className="box-comentarios-video">
        <Video videoName="video8" />

        {projeto?.tipoProjetoId &&
        projeto.tipoProjetoId !== 2 &&
        filters?.ciclo &&
        filters.ciclo.anoMesCiclo && (
            <CriarDashboardButton
              onClick={handleAbrirCriarDashboard}
            />
        )}

      </div>
      
      <Grafico nlsContexto={nlsContexto} labelgraf={labelgraf} imprimir={totalAvaliacao > 0}/>

      <Criar />
      
    </div>
  )
}
